import * as React from "react";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { FormControl, Grid, InputLabel, Select, Typography, Box, Divider } from "@mui/material";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

export default function RentalsForm(props) {
  const { errors } = props;
  return (
    <Box sx={{ p: 2 }}>
      <Grid container component="form" noValidate autoComplete="off" spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            size="small"
            fullWidth
            label="Property Name"
            onChange={props.handleRentalNameChange}
            error={Boolean(errors.rental_name)}
            helperText={errors.rental_name}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth size="small">
            <InputLabel id="demo-simple-select-label">Property Use Type</InputLabel>
            <Select
              label="Property Use Type"
              labelId="rental-type"
              id="rental-type-id"
              value={props.rentalType}
              onChange={props.handleChangeRentalType}
              error={Boolean(errors.rental_type)}
            >
              <MenuItem value="MIXED USE">Mixed Use</MenuItem>
              <MenuItem value="RESIDENTIAL">Residential</MenuItem>
              <MenuItem value="COMMERCIAL">Commercial</MenuItem>
            </Select>
            {errors.rental_type && (
              <Typography color="maroon" variant="caption">
                {errors.rental_type}
              </Typography>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Property Location (City)"
            id="property-location"
            fullWidth
            size="small"
            value={props.rentalCity}
            onChange={props.handleRentalCityChange}
            error={Boolean(errors.location)}
            helperText={errors.location}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Google Map Location"
            id="google-map-location"
            fullWidth
            size="small"
            value={props.locationUrl}
            onChange={props.handleLocationUrlChange}
            error={Boolean(errors.location_url)}
            helperText={errors.location_url}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            size="small"
            fullWidth
            label="Property Location (Parish & County)"
            onChange={props.handleRentalLocationChange}
            error={Boolean(errors.location_county)}
            helperText={errors.location_county}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            size="small"
            fullWidth
            label="Pay Percentage (%)"
            type="number"
            value={props.payPercentage || ""}
            onChange={props.handlePayPercentageChange}
            error={Boolean(errors.pay_percentage)}
            helperText={errors.pay_percentage || "Percentage to be paid to the platform for this property"}
            inputProps={{ min: 0, max: 100, step: 0.01 }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            size="small"
            fullWidth
            label="Pay Percentage Effective Date"
            type="date"
            value={props.payPercentageEffectiveDate || ""}
            onChange={props.handlePayPercentageEffectiveDateChange}
            error={Boolean(errors.pay_percentage_effective_date)}
            helperText={errors.pay_percentage_effective_date || "Date when this pay percentage becomes effective"}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12}>
          <Divider sx={{ my: 2 }} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormGroup>
            <FormControlLabel
              control={<Checkbox checked={props.security} onChange={props.handleSecurityCheck} />}
              label="Has 24 Hour Security?"
            />
            <FormControlLabel
              control={<Checkbox checked={props.gym} onChange={props.handleGymCheck} />}
              label="Has Gym?"
            />
            <FormControlLabel
              control={<Checkbox checked={props.swimmingPool} onChange={props.handleSwimmingPoolCheck} />}
              label="Has Swimming Pool?"
            />
          </FormGroup>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormGroup>
            <FormControlLabel
              control={<Checkbox checked={props.elevator} onChange={props.handleElevatorCheck} />}
              label="Has Elevator?"
            />
            <FormControlLabel
              control={<Checkbox checked={props.hospital} onChange={props.handleHospitalCheck} />}
              label="Hospital Access in less than 10 minutes"
            />
            <FormControlLabel
              control={<Checkbox checked={props.mainRoad} onChange={props.handleMainRoadCheck} />}
              label="Main Road Access in less than 5 minutes"
            />
          </FormGroup>
        </Grid>
      </Grid>
    </Box>
  );
}
